import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, Col, Row, Label } from 'reactstrap';
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, {
    Search,
} from "react-bootstrap-table2-toolkit";
import "../../../../node_modules/react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { withNamespaces } from 'react-i18next';
import { formatUnitsForReport } from '../../../helpers/units';
import moment from 'moment';
import { postSubmitForm } from '../../../helpers/forms_helper';
import showNotification from '../../../helpers/show_notification';

const ViewCompleteDetails = ({isOpen,toggle,order,t}) => {

    const columns = [
        {
            dataField: "_id",
            hidden: true,
        },
        {
            dataField: "order_to",
            text: t("Order To"),
            headerStyle: (colum, colIndex) => {
              return { width: "12%" };
            },
          },
        {
            dataField: "category",
            text: t("Category"),
            headerStyle: (colum, colIndex) => {
                return { width: "12%" };
            },
        },
        {
            dataField: "sub_category",
            text: t("Sub-Category"),
            headerStyle: (colum, colIndex) => {
                return { width: "12%" };
            },
        },
        {
            dataField: "name",
            text: t("Item"),
            headerStyle: (colum, colIndex) => {
                return { width: "15%" };
            },
            sort: true,
        },
        {
            text: t("From Supplier"),
            dataField: "direct_po",
            formatter: (cell, row) => {
                return row.direct_po ? "Yes" : "No"
            },
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: "10%" };
            },
        },
        {
            dataField: "available",
            text: `${order?.branch_details?.type === "Branch" ? "Branch Avl. Qty." : "Store Avl. Qty."}`,
            formatter: (cell, row) => {
                return formatUnitsForReport(row.available, row.unit_levels)
            },
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: "15%" };
            },
        },
        {
            dataField: "quantity",
            text: t("Order Quantity"),
            formatter: (cell, row) => {
                return formatUnitsForReport(row.quantity)
            },
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: "15%" };
            },
        },
    ];

    const columns_delivered_items = [
        {
            text: t("Category"),
            dataField: "category",
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: "12%" };
            },
        },
        {
            text: t("Item"),
            dataField: "name",
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: "18%" };
            },
        },
        {
            text: t("Batch"),
            dataField: "batch",
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: "10%" };
            },
        },

        {
            text: t("Dispatch Time"),
            dataField: "date_of_transaction",
            formatter: (cell, row) => {
                return moment(row.date_of_transaction).format("DD/MM/YYYY HH:mm");
            },
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: "9%" };
            },
        },
        {
            dataField: "delivered_from",
            text: t("Delivered from."),
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: "15%" };
            },
        },
        {
            dataField: "delivered_quantity",
            text: t("Delivered Qty."),
            formatter: (cell, row) => {
                return formatUnitsForReport(row.delivered_quantity)
            },
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: "15%" };
            },
        },
        {
            dataField: "received_quantity",
            text: t("Rec. Qty."),
            formatter: (cell, row) => {
                return formatUnitsForReport(row.received_quantity, row.unit_levels)
            },
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: "15%" };
            },
        },
        {
            text: t("Received ?"),
            dataField: "is_received",
            formatter: (cell, row) => {
                return row.is_received ? "Yes" : "No";
            },
            headerStyle: (colum, colIndex) => {
                return { width: "8%" };
            },
        },
         {
            text: t("Remarks"),
            dataField: "remarks",
            headerStyle: (colum, colIndex) => {
                return { width: "8%" };
            },
        },
    ];

    const PO_Columns = [
        {
            dataField: "item_id",
            hidden: true,
        },
        {
            text: t("Category"),
            dataField: "category",
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: "10%" };
            },
            footer: false,
        },
        {
            text: t("Supplier"),
            dataField: "supplierName",
            sort: true,
            hidden: !order?.po_bucket_status === "PO Generated",
            headerStyle: (colum, colIndex) => {
                return { width: "10%" };
            },
            footer: false,
        },
        {
            text: t("Sub Category"),
            dataField: "sub_category",
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: "10%" };
            },
            footer: false,
        },
        {
            text: t("Item"),
            dataField: "name",
            sort: false,
            headerStyle: (colum, colIndex) => {
                return { width: "20%" };
            },
            footer: false,
        },
        {
            text: t("Order Qty."),
            dataField: "quantity",
            sort: false,
            editable: false,
            formatter: (cell, row) => {
                return formatUnitsForReport(row.quantity);
            },
            headerStyle: (colum, colIndex) => {
                return { width: "15%" };
            },
            footer: false,
        },
        {
            text: t("Price"),
            dataField: "po_price",
            formatter: (cell, row) => {
                return (row.po_price || 0) + " / " + row.unit_for_po;
                // return 0
            },
            sort: false,
            editable: true,
            headerStyle: (colum, colIndex) => {
                return { width: "8%" };
            },
            footer: false,
        },
        {
            text: t("Total"),
            dataField: "total_price",
            sort: false,
            formatter: (cell, row) => {
                return row?.total_price?.toFixed(2) || 0;
            },
            headerStyle: (colum, colIndex) => {
                return { width: "8%" };
            },
            editable: false,
            hidden: !order?.po_bucket_status === "PO Generated",

            // footer: (columnData) => {
            //     const total = columnData.reduce((acc, item) => acc + item, 0);
            //     return total.toFixed(2);
            // },
        },
    ];

    const [POItems, setPOItems] = useState([]);

    const loadSuppliers = async (category) => {
        let url = process.env.REACT_APP_BASEURL + "suppliers/get_by_categories";
        let response = await postSubmitForm(url, { categories: [category] });
        if (response.status === 1) {
            return response.data;
        } else {
            showNotification(response.message, "Error");
            return [];
        }
    };

    async function addSupplierNamesToItems(po_bucket) {
        const allItems = [];
        for (const bucket of po_bucket) {
            const { category, supplier: supplierId, items } = bucket;

            const suppliers = await loadSuppliers(category);            
            const updatedItems = items.map(item => {
                const supplier = suppliers.find(s => s.value === supplierId);
                const supplierName = supplier ? supplier.name : "N/A";
                return {
                    ...item,
                    supplierId,      
                    supplierName,    
                    category         
                };
            });
            allItems.push(...updatedItems);
        }
        return allItems;
    }

    useEffect(() => {
        const fetchItems = async () => {
            if (order?.po_bucket_status === "PO Generated") {
                const itemsWithSuppliers = await addSupplierNamesToItems(order.po_bucket);
                setPOItems(itemsWithSuppliers);
            } else {
                setPOItems(order?.po_bucket || []);
            }
        };

        if (order) {
            fetchItems(); 
        }
    }, [order]);  

  return (
    <>
      <Modal isOpen={isOpen} toggle={toggle} onClosed={toggle} size="xl">
            <ModalHeader toggle={toggle}>
                Order Id : {order?.order_id}
            </ModalHeader>
            <ModalBody>
                {/* ordered  items  */}
                <Row>
                    <Col lg={12} md={12}>
                        <Label>Ordered Items</Label>
                    </Col>

                    <Col lg={12}>
                        <BootstrapTable
                            bootstrap4
                            keyField="_id"
                            data={order && order.item_details}
                            columns={columns}
                            noDataIndication="No data to display."
                            striped
                            hover
                            condensed
                        />
                        <hr />
                    </Col>
                </Row>

                {/* dispatched items  */}
                  {order && order.delivery_details?.length>0 && (
                      <Row>
                          <Col lg={12} md={12}>
                              <Label>Dispatched Items</Label>
                          </Col>

                          <Col lg={12}>
                              <BootstrapTable
                                  bootstrap4
                                  keyField="_id"
                                  data={order && order.delivery_details}
                                  columns={columns_delivered_items}
                                  noDataIndication="No data to display."
                                  striped
                                  hover
                                  condensed
                              />
                              <hr />
                          </Col>
                      </Row>
                  )}

                  {/* PO items  */}
                  {order && order.po_bucket?.length > 0 && order.po_bucket_status === "PO Generated" && (
                      <Row>
                          <Col lg={12} md={12}>
                              <Label>
                                  {t("Purchase Order generated for below items")}
                              </Label>                         
                         </Col>

                          <Col lg={12}>
                              <BootstrapTable
                                  bootstrap4
                                  keyField="_id"
                                  data={POItems||[]}
                                  columns={PO_Columns}
                                  noDataIndication="No data to display."
                                  striped
                                  hover
                                  condensed
                              />
                              <hr />
                          </Col>
                      </Row>
                  )}
            </ModalBody>
        </Modal>
    </>
  )
}

export default withNamespaces()(ViewCompleteDetails);